var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgKpmgCloseForSubmissionConfirm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90.161,
    height: 71.812,
    viewBox: "0 0 90.161 71.812"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".kpmg-close-for-submission-confirm_svg__cls-2,.kpmg-close-for-submission-confirm_svg__cls-5{fill:none}.kpmg-close-for-submission-confirm_svg__cls-2{stroke:#fff;stroke-linecap:round;stroke-width:1.6px;stroke-linejoin:round}.kpmg-close-for-submission-confirm_svg__cls-4{stroke:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission-confirm_svg__ICN_Modal_confirmare_Inhide_pt_Depunere_Enabled",
    "data-name": "ICN_Modal confirmare Inhide pt Depunere_Enabled",
    transform: "translate(-942.919 -396.389)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "kpmg-close-for-submission-confirm_svg__Path_948",
    d: "M44.5 13.39a4 4 0 016.929 0l41.11 63.81a4 4 0 01-3.465 6H6.926a4 4 0 01-3.465-6z",
    "data-name": "Path 948",
    transform: "translate(940 385)",
    fill: "#009a44"
  }), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission-confirm_svg__ICN_Inchide_pt__Depunere_Enabled",
    "data-name": "ICN_Inchide pt. Depunere_Enabled",
    transform: "translate(1099 1675.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission-confirm_svg__Rectangle_255",
    className: "kpmg-close-for-submission-confirm_svg__cls-2",
    "data-name": "Rectangle 255",
    transform: "translate(-121 -1237.122)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.418,
    height: 16.456,
    className: "kpmg-close-for-submission-confirm_svg__cls-4",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 17.818,
    height: 14.856,
    x: 0.8,
    y: 0.8,
    className: "kpmg-close-for-submission-confirm_svg__cls-5",
    rx: 1.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission-confirm_svg__Rectangle_256",
    className: "kpmg-close-for-submission-confirm_svg__cls-2",
    "data-name": "Rectangle 256"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.747 0a6.747 6.747 0 016.747 6.747v3.895H0V6.747A6.747 6.747 0 016.747 0z",
    className: "kpmg-close-for-submission-confirm_svg__cls-4",
    transform: "translate(-118.038 -1246.338)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.747.8a5.947 5.947 0 015.947 5.947v2.578a.517.517 0 01-.517.517H1.317A.517.517 0 01.8 9.325V6.747A5.947 5.947 0 016.747.8z",
    className: "kpmg-close-for-submission-confirm_svg__cls-5",
    transform: "translate(-118.038 -1246.338)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission-confirm_svg__Group_706",
    "data-name": "Group 706",
    transform: "rotate(180 -54.433 -612.692)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "kpmg-close-for-submission-confirm_svg__Ellipse_164",
    className: "kpmg-close-for-submission-confirm_svg__cls-2",
    "data-name": "Ellipse 164",
    transform: "translate(0 3.986)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.392,
    cy: 2.392,
    r: 2.392,
    className: "kpmg-close-for-submission-confirm_svg__cls-4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.392,
    cy: 2.392,
    r: 1.592,
    className: "kpmg-close-for-submission-confirm_svg__cls-5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "kpmg-close-for-submission-confirm_svg__Line_82",
    d: "M2.392 0v4.783",
    "data-name": "Line 82",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 1.6,
    fill: "none"
  }))))));
}

export default SvgKpmgCloseForSubmissionConfirm;